import React from "react";
import { motion } from "framer-motion";
import NavigationBar from "../comps/NavigationBar/NavigationBar";
import "./style.scss";

function HomeContent2() {
  const width = window.innerWidth;

  return (
    <div>
      <div className="home-content-scroll-long-page">
        {<NavigationBar />}

        <motion.div className="home-content2-page1">
          <motion.div className="home-content1-cells">
            <motion.img
              src="https://static.igem.wiki/teams/4826/wiki/page-1-maincell.svg"
              className="maincell"
            />
            <motion.img
              src="https://static.igem.wiki/teams/4826/wiki/page-1-backcellstar.svg"
              className="backcellstar"
            />
            <motion.img
              src="https://static.igem.wiki/teams/4826/wiki/page-1-backcell.svg"
              className="backcell"
            />
          </motion.div>

          <motion.div className="home-content1-rockets">
            <motion.img
              src="https://static.igem.wiki/teams/4826/wiki/page-1-rocket1.svg"
              className="rocketsmall"
            />
            <motion.img
              src="https://static.igem.wiki/teams/4826/wiki/page-1-rocket1.svg"
              className="rocketfar"
            />
            <motion.img
              src="https://static.igem.wiki/teams/4826/wiki/page-1-rocket1.svg"
              className="rocketnear"
            />
          </motion.div>

          <motion.div className="home-content1-text-background">
            <p className="home-content1-text-title">BioRocket</p>
            <p className="home-content1-text">
              Systematic Discovery of Novel Protein Delivery Systems in Massive
              Prokaryotic Genomes
            </p>
            <br />
            <p className="home-content1-bottom-text">
              &gt;80,000 Prokaryotic Genomes &emsp; Machine Learning and
              Structure Alignments &emsp; <br />
              5,524 Novel Systems &emsp; Wet-lab Experiment Validation
            </p>
          </motion.div>
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/star.svg"
            className="page-4-star"
          />
        </motion.div>

        <motion.div className="home-content2-page2">
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-1-maincell.svg"
            className="page-2-maincell"
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-1-backcellstar.svg"
            className="page-2-backcellstar"
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-1-backcell.svg"
            className="page-2-backcell"
          />

          <motion.div
            className="home-content2-page2-text-background"
            variants={{
              show: { left: "12%", opacity: 1 },
              hide: { left: "12%", opacity: 0.01 },
            }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ duration: 2 }}
          >
            <p className="home-content2-page2-text">
              <span style={{ fontSize: "42px", fontWeight: "bold" }}>
                Inspiration:
              </span>
              <br />
              <br />
              <span style={{ color: "#FFC000", fontSize: "38px" }}>
                Prokaryotes
              </span>{" "}
              harbor numerous diverse and powerful biological systems, including{" "}
              <span style={{ color: "#FFC000", fontSize: "38px" }}>
                protein delivery systems
              </span>{" "}
              that enable these organisms to interface with host cells. (See{" "}
              <a href="https://2023.igem.wiki/sysu-software/description">
                Description
              </a>
              )
            </p>
          </motion.div>
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/star.svg"
            className="page-4-star"
          />
        </motion.div>

        <motion.div className="home-content2-page3">
          <motion.div
            className="home-content2-page3-text-background"
            variants={{
              fly: { left: "6%", opacity: 1 },
              hide: { left: "-40%", opacity: 0.01 },
            }}
            initial={"hide"}
            whileInView={"fly"}
            transition={{ duration: 2 }}
          >
            <p className="home-content2-page3-text">
              <span style={{ fontSize: "28px", fontWeight: "bold" }}>
                Scientific Problem:
              </span>
              <br />
              <br />
              One example, the{" "}
              <span style={{ color: "#ED7D31", fontSize: "24px" }}>
                extracellular Contractile Injection Systems (eCISs)
              </span>
              , are syringe-like protein complexes that can inject proteins into
              cells.
            </p>
            <br />
            <p className="home-content2-page3-text">
              Despite the potential as programmable protein delivery tools,{" "}
              <span style={{ color: "#ED7D31", fontSize: "24px" }}>
                only a few
              </span>{" "}
              eClSs have been characterized to date. (See{" "}
              <a href="https://2023.igem.wiki/sysu-software/description">
                Description
              </a>
              )
            </p>
          </motion.div>
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/star.svg"
            className="page-4-star"
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-3-line.svg"
            className="page-3-line"
            variants={{
              show: { left: "-60%" },
              hide: { left: "-190%" },
            }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ duration: 2 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-3-cell.svg"
            className="page-3-maincell"
            whileInView={{ x: -width * 0.57, zIndex: 2 }}
            transition={{ duration: 2 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-1-backcellstar.svg"
            className="page-3-backcellstar"
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-1-backcell.svg"
            className="page-3-backcell"
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-3-shot.svg"
            className="page-3-shot"
            variants={{
              fly: { top: "-30%", left: "36%", opacity: 1 },
              hide: { top: "50%", left: "10%", opacity: 0.01 },
            }}
            initial={"hide"}
            whileInView={"fly"}
            transition={{ duration: 2 }}
          />
        </motion.div>

        <motion.div className="home-content2-page4">
          <motion.div
            className="home-content2-page4-text-background"
            variants={{
              fly: { left: "6%", opacity: 1 },
              hide: { left: "-50%", opacity: 0.01 },
            }}
            initial={"hide"}
            whileInView={"fly"}
            transition={{ duration: 2 }}
          >
            <p className="home-content2-page4-text">
              <span style={{ fontSize: "28px", fontWeight: "bold" }}>
                Our solution:
              </span>
              <br />
              <br />
              Here, we designed the BioRocket platform to{" "}
              <span style={{ color: "#ED7D31", fontSize: "24px" }}>
                systematically mine eClSs from prokaryotic genomes
              </span>{" "}
              using machine learning and structural computation, and further
              conducted high-throughput predictions of programmable targeting
              regions within eCISs. (See{" "}
              <a href="https://2023.igem.wiki/sysu-software/design">Design</a>,{" "}
              <a href="https://2023.igem.wiki/sysu-software/engineering">
                Engineering
              </a>
              )
            </p>
          </motion.div>
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/star.svg"
            className="page-4-star"
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-4-circle.svg"
            className="page-4-circle"
            variants={{ show: { opacity: 1 }, hide: { opacity: 0 } }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ delay: 1, duration: 1 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-4-sight.svg"
            className="page-4-sight"
            variants={{ show: { opacity: 1 }, hide: { opacity: 0 } }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ delay: 1, duration: 1 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-4-tool.svg"
            className="page-4-tool"
            variants={{ show: { opacity: 1 }, hide: { opacity: 0 } }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ delay: 1, duration: 1 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-4-biorocket-1.svg"
            className="page-4-rocket1"
            variants={{
              fly: { top: "3%", left: "54%", opacity: 1 },
              hide: { top: "90%", left: "30%", opacity: 0 },
            }}
            initial={"hide"}
            whileInView={"fly"}
            transition={{ duration: 2 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-4-biorocket-2.svg"
            className="page-4-rocket2"
            variants={{
              fly: { top: "24%", left: "66%", opacity: 1 },
              hide: { top: "90%", left: "0%", opacity: 0 },
            }}
            initial={"hide"}
            whileInView={"fly"}
            transition={{ duration: 2 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-4-biorocket-3.svg"
            className="page-4-rocket3"
            variants={{
              fly: { top: "53%", left: "66%", opacity: 1 },
              hide: { top: "20%", left: "0%", opacity: 0 },
            }}
            initial={"hide"}
            whileInView={"fly"}
            transition={{ duration: 2 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-4-biorocket-4.svg"
            className="page-4-rocket4"
            variants={{
              fly: { top: "75%", left: "54.5%", opacity: 1 },
              hide: { top: "0%", left: "30%", opacity: 0 },
            }}
            initial={"hide"}
            whileInView={"fly"}
            transition={{ duration: 2 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-4-biorocket-central.svg"
            className="page-4-rocket-central"
            variants={{
              show: { top: "50%", opacity: 1 },
              hide: { top: "100%", opacity: 0 },
            }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ duration: 2 }}
          />
        </motion.div>

        <motion.div className="home-content2-page5">
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/star.svg"
            className="page-4-star"
          />
          <motion.div
            className="home-content2-page5-text-background"
            variants={{
              fly: { left: "8%", opacity: 1 },
              hide: { left: "-70%", opacity: 0.01 },
            }}
            initial={"hide"}
            whileInView={"fly"}
            transition={{ duration: 2 }}
          >
            <p className="home-content2-page5-text ">
              <span style={{ fontSize: "28px", fontWeight: "bold" }}>
                Exciting Results:
              </span>
              <br />
              BioRocket explored over{" "}
              <span style={{ color: "#ED7D31", fontSize: "26px" }}>
                80,000
              </span>{" "}
              prokaryotic organisms and identified{" "}
              <span style={{ color: "#ED7D31", fontSize: "26px" }}>5,524</span>{" "}
              novel eCISs. We further performed wet-lab experiments to validate
              these novel eCISs identified by BioRocket. (See{" "}
              <a href="https://2023.igem.wiki/sysu-software/model">Model</a>,{" "}
              <a href="https://2023.igem.wiki/sysu-software/proof-of-concept">
                Proof of Concept
              </a>
              )
            </p>
          </motion.div>
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-5-line.svg"
            className="page-5-line"
            variants={{
              show: { left: "-19%", zIndex: -0 },
              hide: { left: "-88%" },
            }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ duration: 2 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-5-ball.svg"
            className="page-5-ball"
            variants={{
              show: { left: "38%", top: "2%", width: "50%", opacity: 1 },
              hide: { left: "50%", top: "50%", width: "0%", opacity: 0 },
            }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ duration: 2 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-5-newcomputer.svg"
            className="page-5-computer"
            variants={{
              show: { top: "30%", opacity: 1 },
              hide: { top: "90%", opacity: 0.01 },
            }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ duration: 1 }}
          />
        </motion.div>

        <motion.div className="home-content2-page6">
          <motion.div
            className="home-content2-page6-text-background"
            variants={{
              fly: { left: "6%", opacity: 1 },
              hide: { left: "-70%", opacity: 0.01 },
            }}
            initial={"hide"}
            whileInView={"fly"}
            transition={{ duration: 2 }}
          >
            <p className="home-content2-page6-text">
              <span style={{ fontSize: "28px", fontWeight: "bold" }}>
                Potential applications：
              </span>
              <br />
              <br />
              The extensive eCIS database in BioRocket will catalyze the
              advancement of eCIS as novel delivery tools in synthetic biology.
              (See{" "}
              <a href="https://2023.igem.wiki/sysu-software/contribution">
                Contribution
              </a>
              ,{" "}
              <a href="https://2023.igem.wiki/sysu-software/entrepreneurship">
                Entrepreneurship
              </a>
              )
            </p>
          </motion.div>
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-6-ball.svg"
            className="page-6-ball"
            variants={{
              show: { left: "0%", top: "0%", width: "100%", opacity: 1 },
              hide: { left: "50%", top: "50%", width: "0%", opacity: 0 },
            }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ duration: 2 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-6-gene.svg"
            className="page-6-gene"
            variants={{ show: { opacity: 1 }, hide: { opacity: 0 } }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ duration: 2 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-6-cancer.svg"
            className="page-6-cancer"
            variants={{ show: { opacity: 1 }, hide: { opacity: 0 } }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ duration: 2 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-6-biocontrol.svg"
            className="page-6-biocontrol"
            variants={{ show: { opacity: 1 }, hide: { opacity: 0 } }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ duration: 2 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-6-genetext.svg"
            className="page-6-geneText"
            variants={{ show: { opacity: 1 }, hide: { opacity: 0 } }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ duration: 2 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-6-cancertext.svg"
            className="page-6-cancerText"
            variants={{ show: { opacity: 1 }, hide: { opacity: 0 } }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ duration: 2 }}
          />
          <motion.img
            src="https://static.igem.wiki/teams/4826/wiki/page-6-biocontroltext.svg"
            className="page-6-biocontrolText"
            variants={{ show: { opacity: 1 }, hide: { opacity: 0 } }}
            initial={"hide"}
            whileInView={"show"}
            transition={{ duration: 2 }}
          />
        </motion.div>
      </div>
    </div>
  );
}

export default HomeContent2;
